// extracted by mini-css-extract-plugin
module.exports = {"catalogContent":"style_catalogContent__3CRS6","pagination":"style_pagination__2Ew_Y"};